(function () {
  const wraps = document.querySelectorAll('.blog-track-wrap');
  if (!wraps.length) return;

  const scrollStep = 344; // card width (320) + gap (24)

  // Arrow navigation
  wraps.forEach(function (wrap) {
    const section = wrap.closest('.blog-section');
    if (!section) return;

    const prevBtn = section.querySelector('.blog-arrow--prev');
    const nextBtn = section.querySelector('.blog-arrow--next');

    function updateArrows() {
      if (prevBtn) prevBtn.disabled = wrap.scrollLeft <= 0;
      if (nextBtn) nextBtn.disabled = wrap.scrollLeft + wrap.clientWidth >= wrap.scrollWidth - 1;
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        wrap.scrollBy({ left: -scrollStep, behavior: 'smooth' });
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        wrap.scrollBy({ left: scrollStep, behavior: 'smooth' });
      });
    }

    wrap.addEventListener('scroll', updateArrows, { passive: true });
    updateArrows();
  });

  // Nudge animation on first scroll into view
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const observer = new IntersectionObserver(
    function (entries, obs) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        obs.unobserve(entry.target);

        const wrap = entry.target;
        setTimeout(function () {
          wrap.scrollTo({ left: 72, behavior: 'smooth' });
          setTimeout(function () {
            if (wrap.scrollLeft <= 80) {
              wrap.scrollTo({ left: 0, behavior: 'smooth' });
            }
          }, 700);
        }, 500);
      });
    },
    { threshold: 0.4 }
  );

  wraps.forEach(function (w) {
    observer.observe(w);
  });
})();
